/**
 * Step 1 - Cel planu
 * User wybiera cel: zapytania, wiadomości, sprzedaż, rozpoznawalność
 * 
 * PREMIUM VERSION - Enhanced cards, better selection state
 */
import React from 'react';
import { MessageSquare, ShoppingBag, Users, Eye, Check } from 'lucide-react';

const GOALS = [
  {
    id: 'inquiries',
    label: 'Więcej zapytań od klientów',
    description: 'Chcę, żeby klienci dzwonili, pisali i pytali o moją ofertę',
    icon: MessageSquare,
    gradient: 'from-orange-500 to-orange-600',
    lightBg: 'bg-orange-50'
  },
  {
    id: 'messages',
    label: 'Więcej wiadomości na profilu',
    description: 'Chcę budować relacje i odpowiadać na pytania klientów',
    icon: Users,
    gradient: 'from-blue-500 to-cyan-600',
    lightBg: 'bg-blue-50'
  },
  {
    id: 'sales',
    label: 'Więcej sprzedaży konkretnej oferty',
    description: 'Mam konkretny produkt lub usługę, którą chcę promować',
    icon: ShoppingBag,
    gradient: 'from-emerald-500 to-teal-600',
    lightBg: 'bg-emerald-50'
  },
  {
    id: 'awareness',
    label: 'Budowanie rozpoznawalności',
    description: 'Chcę, żeby więcej osób wiedziało o mojej firmie',
    icon: Eye,
    gradient: 'from-amber-500 to-orange-600',
    lightBg: 'bg-amber-50'
  }
];

export default function StepGoal({ value, onChange }) {
  return (
    <div className="space-y-8">
      {/* Header */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-3">
          Jaki jest cel tego planu?
        </h2>
        <p className="text-gray-600 text-lg">
          Dobierzemy treści i wezwania do działania tak, żeby miały sens — nie tylko zasięgi.
        </p>
      </div>
      
      {/* Goals grid */}
      <div className="grid gap-4">
        {GOALS.map((goal) => {
          const isSelected = value === goal.id;
          const Icon = goal.icon;
          
          return (
            <button
              key={goal.id}
              type="button"
              onClick={() => onChange(goal.id)}
              className={`
                w-full p-6 rounded-2xl border-2 text-left transition-all duration-200
                ${isSelected 
                  ? `border-transparent bg-gradient-to-r ${goal.gradient} shadow-xl shadow-orange-500/20 scale-[1.02]` 
                  : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-md'
                }
              `}
            >
              <div className="flex items-start gap-5">
                {/* Icon */}
                <div className={`
                  w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0 transition-all
                  ${isSelected 
                    ? 'bg-white/20 backdrop-blur-sm' 
                    : `bg-gradient-to-br ${goal.gradient}`
                  }
                `}>
                  <Icon className="w-7 h-7 text-white" />
                </div>
                
                {/* Content */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <h3 className={`text-lg font-bold ${isSelected ? 'text-white' : 'text-gray-900'}`}>
                      {goal.label}
                    </h3>
                    {isSelected && (
                      <div className="w-7 h-7 rounded-full bg-white/30 flex items-center justify-center">
                        <Check className="w-5 h-5 text-white" />
                      </div>
                    )}
                  </div>
                  <p className={`text-base mt-1 ${isSelected ? 'text-white/90' : 'text-gray-500'}`}>
                    {goal.description}
                  </p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
